module.exports = __webpack_public_path__ + "static/media/renter-advantage-co-brand_logo.3dc7b136.svg";